module.exports = __webpack_public_path__ + "sq3-0a153234.png";